module.exports = __webpack_public_path__ + "img/bg-pink.989a5be9.png";